import React, { useEffect, useState } from "react";
import {
    UserPlus,
    Building2,
    Settings2,
    Zap,
    CheckCircle2,
    ArrowRight,
    ShieldCheck,
    BookOpen,
    Brain,
    User,
    Activity,
    MapPin,
    Search,
    Menu,
    X
} from "lucide-react";

// IMPORTANT: Ensure these files exist in your directory
import AdminChecklist from "./adminChecklist";
import CreateAccount from "./adminCreateAccount";
import CreateProgram from "./adminCreateProgram";
import MetricsPage from "./adminScores";
import TrainingPage from "./adminSwot";
import ProfilePage from "./adminProfile";

export default function AdminDocs() {
    const [activeTab, setActiveTab] = useState("onboarding");
    const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [activeTab]);

    const menuItems = [
        { id: "onboarding", label: "Getting Started", icon: BookOpen },
        { id: "create", label: "Create Account", icon: UserPlus },
        { id: "program", label: "Create Program", icon: Building2 },
        { id: "metrics", label: "Data & Metrics", icon: Activity },
        { id: "training", label: "SWOT Analysis", icon: Brain },
        { id: "profile", label: "Program Profile", icon: User },
    ];

    const renderActivePage = () => {
        switch (activeTab) {
            case "onboarding": return <AdminChecklist onNavigate={setActiveTab} />;
            case "create": return <CreateAccount />;
            case "program": return <CreateProgram />;
            case "profile": return <ProfilePage />;
            case "training": return <TrainingPage />;
            case "metrics": return <MetricsPage />;
            default: return <AdminChecklist onNavigate={setActiveTab} />;
        }
    };

    // --- RENDER RETURN ---
    return (
        <div className="min-h-screen bg-gray-50 flex flex-col md:flex-row">
            {/* Sidebar */}
            <aside className={`fixed inset-y-0 left-0 z-50 w-64 bg-white border-r border-gray-200 transform ${isMobileMenuOpen ? "translate-x-0" : "-translate-x-full"} md:translate-x-0 md:static transition-transform duration-200 ease-in-out`}>
                <div className="p-6">
                    <a href="/home" className="flex pb-8 items-center gap-2 cursor-pointer group">
                        <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center text-white font-bold transition-transform group-hover:scale-105">
                            <Zap size={18} fill="currentColor" />
                        </div>
                        <span className="text-xl font-bold tracking-tight text-slate-900">
                            Nuvio<span className="text-blue-600">Sport</span>
                        </span>
                    </a>

                    <nav className="space-y-1">
                        {menuItems.map((item) => (
                            <button
                                key={item.id}
                                onClick={() => { setActiveTab(item.id); setMobileMenuOpen(false); }}
                                className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-bold transition-all ${activeTab === item.id
                                        ? "bg-purple-50 text-purple-700 shadow-sm"
                                        : "text-gray-500 hover:bg-gray-50"
                                    }`}
                            >
                                <item.icon size={18} />
                                {item.label}
                            </button>
                        ))}
                    </nav>
                </div>
            </aside>

            {/* Main Content Area */}
            <main className="flex-1 overflow-y-auto p-6 md:p-12">
                {/* Mobile Toggle */}
                <button
                    onClick={() => setMobileMenuOpen(!isMobileMenuOpen)}
                    className="md:hidden mb-6 p-2 bg-white border border-gray-200 rounded-lg"
                >
                    {isMobileMenuOpen ? <X /> : <Menu />}
                </button>

                <div className="max-w-4xl mx-auto">
                    {renderActivePage()}
                </div>
            </main>
        </div>
    );
}